import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine class names - supports conditional classes (clsx) and resolves
 * Tailwind class conflicts (twMerge). Standard shadcn pattern.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
